module.exports = __webpack_public_path__ + "img/logo_bak.ffe3bc3b.png";